import React from 'react';
import { Users, MapMarkerAlt, Wrench } from 'styled-icons/fa-solid';
import { AccessTime } from 'styled-icons/material';

import { mapCurrencyIcon } from '@src/helpers/mapCurrencyIcon';
import { BaseBox, Flex } from 'src/kit';

export const JobDescriptionLabels = ({ job, iconColor, ...styledProps }) => {
  const CurrencyIcon = mapCurrencyIcon[job.currency];

  return (
    <Flex flexWrap="wrap" {...styledProps}>
      <JobFieldSet icon={Users} iconColor={iconColor}>
        {job?.team?.name}
      </JobFieldSet>
      <JobFieldSet icon={MapMarkerAlt} iconColor={iconColor}>
        {job?.office?.city}
      </JobFieldSet>
      <JobFieldSet icon={AccessTime} iconColor={iconColor}>
        {job.employment_type}
      </JobFieldSet>
      <JobFieldSet icon={CurrencyIcon} iconColor={iconColor}>
        {job.salary}
      </JobFieldSet>
      <JobFieldSet icon={Wrench} iconColor={iconColor}>
        {job.job_functions.join(', ')}
      </JobFieldSet>
    </Flex>
  );
};

export const JobFieldSet = ({ children, icon: Icon, iconColor }: any) =>
  children ? (
    <Flex mr={15} mb={10} alignItems="center">
      <BaseBox as={Icon} size={14} color={iconColor} />
      <BaseBox ml={5}>{children}</BaseBox>
    </Flex>
  ) : null;
